import logo from './logo.svg';
import './App.css';

function App() {
  

  return (
    
    <div className="App">
      <header className="App-header">
        
        <p>
          <strong>Hello World</strong> <br></br>
          Welcome to ReactJS
        </p>
        <p>ทดสอบ ReactJS กับ ไชโย โฮสติ้ง</p>
        <img src={logo} className="App-logo" alt="logo" />
        
        
      </header>
    </div>
  );
}

export default App;
